import { SendModalShell } from './SendModalShell.js';
import { SendForm } from './SendForm.js';

interface SendChecklistModalProps {
  open: boolean;
  onClose: () => void;
  course: {
    id: string;
    name: string;
    provider_name?: string;
    cricos_code?: string | null;
  };
}

export function SendChecklistModal({ open, onClose, course }: SendChecklistModalProps) {
  return (
    <SendModalShell open={open} onClose={onClose}>
      <SendForm kind="checklist" course={course} onClose={onClose} />
    </SendModalShell>
  );
}
